import { simulationsClient } from '~/services/api/simulations-client';

export const getSystemSimulation = async ({
  simulationId,
}: {
  simulationId: string;
}) =>
  simulationsClient.getSimulation({
    runAttemptName: simulationId,
  });
